import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { SearchByType } from '../enums/enums'
import { ITrack } from '../Interface/track'
import { ProducerSearchItemType } from '../types/producer.type'
import { CoreEnvironmentService } from './core-environment.service'

export interface IStyleOrMood {
  Id: number
  Name: string
  Type: 'style' | 'mood'
}

export type SearchResponseType = {
  value: string
  id: number
}

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  baseUrl: string

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  getData(
    searchBy: SearchByType,
    searchText: string
  ): Observable<ITrack[] | ProducerSearchItemType[] | IStyleOrMood[]> {
    const url = this.baseUrl + `/web/v1/search?itemType=${searchBy}&query=${searchText}`
    return this.http.get<ITrack[] | ProducerSearchItemType[] | IStyleOrMood[]>(url)
  }

  getTagIdBySearch(search: string): Observable<SearchResponseType[]> {
    return this.http.get<SearchResponseType[]>(`${this.baseUrl}/beats/Beats/FindTags?term=${search}`)
  }

  getBeatmakerIdBySearch(search: string): Observable<SearchResponseType[]> {
    return this.http.get<SearchResponseType[]>(`${this.baseUrl}/Beatmakers/Beatmakers/FindBeatmaker?term=${search}`)
  }
}
